import { DEFAULT_MODAL_STATE } from './useModalStore.js';
import { LoginModalStepNumber, LoginPreviousStep, SignUpModalStepNumber, SignUpPreviousStep } from '../../utils/steps.js';
export const getActions = (set, get) => ({
    resetState: () => {
        set(DEFAULT_MODAL_STATE);
    },
    setOnModalStepChange: onModalStepChange => {
        set({ onModalStepChange });
    },
    setStep: step => {
        const onModalStepChange = get().onModalStepChange;
        const previousStep = get().step;
        set({ step });
        onModalStepChange === null || onModalStepChange === void 0 ? void 0 : onModalStepChange({ previousStep, currentStep: step, canGoBack: get().hasPreviousStep() });
    },
    decrementStep: () => {
        const onModalStepChange = get().onModalStepChange;
        const isLogin = get().flow === 'login';
        const currentStep = get().step;
        const prevStep = (isLogin ? LoginPreviousStep : SignUpPreviousStep)[currentStep];
        if (prevStep) {
            set({ step: prevStep });
            onModalStepChange === null || onModalStepChange === void 0 ? void 0 : onModalStepChange({ previousStep: currentStep, currentStep: prevStep, canGoBack: get().hasPreviousStep() });
        }
    },
    hasPreviousStep: () => {
        const isLogin = get().flow === 'login';
        const currentStep = get().step;
        return !!(isLogin ? LoginPreviousStep[currentStep] : SignUpPreviousStep[currentStep]);
    },
    stepNumber: () => {
        const isLogin = get().flow === 'login';
        const currentStep = get().step;
        const stepNumbers = isLogin ? LoginModalStepNumber : SignUpModalStepNumber;
        return stepNumbers[currentStep];
    },
    totalSteps: () => {
        const isLogin = get().flow === 'login';
        let numOfSkippedOptionalSteps = 0;
        // If no on ramp config is provided, remove extra steps
        if (!get().onRampConfig) {
            numOfSkippedOptionalSteps++;
        }
        const stepNumbersValues = Object.values(isLogin ? LoginModalStepNumber : SignUpModalStepNumber);
        return stepNumbersValues[stepNumbersValues.length - 1] - numOfSkippedOptionalSteps;
    },
    setFlow: flow => {
        set({ flow });
    },
    isLogin: () => {
        return get().flow === 'login';
    },
    setWebAuthURLForLogin: url => {
        set({ webAuthURLForLogin: url });
    },
    setWebAuthURLForCreate: url => {
        set({ webAuthURLForCreate: url });
    },
    setOnRampPurchase: onRampPurchase => {
        set(state => ({ onRampPurchase: Object.assign(Object.assign({}, (state.onRampPurchase || {})), onRampPurchase) }));
    },
    setOnRampConfig: onRampConfig => {
        set({ onRampConfig });
    },
    setNetworks: networks => {
        set({ networks });
    },
    setLoginWindow: loginWindow => {
        set({ loginWindow });
    },
});
